var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"el",staticClass:"h-full w-full relative"},[_c('canvas',{ref:"chart",attrs:{"id":"myChart"}})])}
var staticRenderFns = []

export { render, staticRenderFns }